import React from 'react'
import { Item, List } from '../../../layout/List'
import { format } from 'date-fns'
import tw from 'twin.macro'
import { ATag } from '../../../styles/Link'
import config from '../../../config'

export const AvailableList = ({ prize = {} }) => {
  const { availablePrizes, createdAt, validTo } = prize

  return (
    <>
      <List.Sticky>
        <List.Header>
          <ListData>Instance Id</ListData>
          <ListData>Created At</ListData>
          <ListData>Valid Until</ListData>
        </List.Header>
      </List.Sticky>

      <List.Container>
        {availablePrizes?.length ? (
          availablePrizes.map(({ id }, i) => (
            <Item.Container key={i}>
              <Item.Header>
                <ItemData>
                  {id ? (
                    <ATag
                      href={`${config.firebase.FIRESTORE_URL}/prizes/${prize.id}/available/${id}`}
                    >
                      {id}
                    </ATag>
                  ) : (
                    '-'
                  )}
                </ItemData>
                <ItemData>{createdAt ? format(createdAt, 'LLL do yyyy, HH:mm') : '-'}</ItemData>
                <ItemData>{validTo ? format(validTo, 'LLL do yyyy, HH:mm') : '-'}</ItemData>
              </Item.Header>
            </Item.Container>
          ))
        ) : (
          <List.Empty>{'Nothing here...'}</List.Empty>
        )}
      </List.Container>
    </>
  )
}

const ListData = tw(List.HeaderData)`px-4`
const ItemData = tw(Item.HeaderData)`px-4`
